export enum InvoiceDisplayChoices {
  drafts= 'drafts',
  open= 'open',
  all= 'all'
}
